import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const CompanyMatchingSearchPage = withSuspense(lazy(() => import('./company-search')));
export default CompanyMatchingSearchPage;
